<template>
  <v-toolbar dark color="blue darken-2">
    <v-toolbar-title class="white--text">
      <router-link to="/" class="white--text" style="text-decoration:none;">WZ_Images</router-link>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <!-- {{search_image}} -->
    <v-layout class="pt-2" v-if="showNavInput">
      <v-flex xs12 sm6 offset-sm6>
        <v-form v-on:submit.prevent="search_img">
          <v-text-field
            v-model="search_val"
            solo
            label="Images search..."
            append-icon="search"
            light
          ></v-text-field>
        </v-form>
      </v-flex>
    </v-layout>
    <v-toolbar-items>
      <v-btn flat to="/mycollections" class="hidden-xs-only">Collections</v-btn>
      <v-btn flat to="/mycollections" class="hidden-sm-and-up">
        <v-icon large class="ml-3">art_track</v-icon>
      </v-btn>
      <v-badge right color="orange darken-4 mt-3 mr-3">
        <span slot="badge" small style="font-size:12px;">{{this.$store.getters.collections.length}}</span>
      </v-badge>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "navbar",

  data() {
    return {
      search_val: ""
    };
  },

  computed: {
    showNavInput: function() {
      if (this.$route.path === "/") {
        return false;
      }
      return true;
    }
  },

  methods: {
    ...mapActions(["SearchImages"]),
    search_img: function() {
      this.SearchImages(this.search_val);
      this.$router.replace({ path: `/search/${this.search_val}` });
    }
  }
};
</script>
